var _path, _rect, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConnClevertap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H93.6641C98.0823 0 101.664 3.58172 101.664 8V93.6641C101.664 98.0823 98.0823 101.664 93.6641 101.664H8C3.58172 101.664 0 98.0823 0 93.6641V8Z",
    fill: "#EE4444",
    fillOpacity: 0.1
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.5,
    y: 14.5,
    width: 73,
    height: 73,
    fill: "#EE4444",
    stroke: "#313131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.2803 31.6926C44.0028 32.8796 43.6263 34.4276 42.4394 35.1501C37.3556 38.2447 33.9698 43.8317 33.9698 50.2073C33.9698 59.9346 41.8553 67.8202 51.5827 67.8202C55.0782 67.8202 58.3289 66.8044 61.0647 65.0529C62.235 64.3036 63.7911 64.645 64.5404 65.8153C65.2897 66.9856 64.9484 68.5417 63.778 69.291C60.2565 71.5456 56.0683 72.8524 51.5827 72.8524C39.0761 72.8524 28.9375 62.7138 28.9375 50.2073C28.9375 42.0035 33.3015 34.8213 39.8227 30.8516C41.0097 30.1291 42.5577 30.5056 43.2803 31.6926Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7084 62.2097C71.7084 63.7062 70.4953 64.9194 68.9987 64.9194C67.5022 64.9194 66.2891 63.7062 66.2891 62.2097C66.2891 60.7132 67.5022 59.5 68.9987 59.5C70.4953 59.5 71.7084 60.7132 71.7084 62.2097Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnClevertap);
export default __webpack_public_path__ + "static/media/conn_clevertap.222d700309959249c78449703f76b056.svg";
export { ForwardRef as ReactComponent };